import * as _4 from 'lodash4';
import { ChoiceSelectorController } from '../components/choice_selector/choice_selector';

export class AppointmentsChoiceSelectorServant {
  private choiceSelectors: ChoiceSelectorController[];

  constructor() {
    this.refresh();
  }

  refresh() {
    this.choiceSelectors = [];
  }

  add(choiceSelectorItem: ChoiceSelectorController) {
    this.choiceSelectors.push(choiceSelectorItem);
  }

  remove(choiceSelectorItem: ChoiceSelectorController) {
    const idx = this.choiceSelectors.indexOf(choiceSelectorItem);
    this.choiceSelectors.splice(idx, 1);
  }

  next(choiceSelectorItem: ChoiceSelectorController) {
    const nextChoiceSelector = this.choiceSelectors.slice(-1)[0];
    choiceSelectorItem.toggleChoice();
    if (choiceSelectorItem !== nextChoiceSelector) {
      nextChoiceSelector.toggleChoice();
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointments_choice_selector_servant.ts